import React from "react";
import { useLocation } from "react-router-dom";
import { View } from "./View";
import { mergeUrl } from "core/utils";
export var IframeEmbed = function (_a) {
    var url = _a.url, displayMode = _a.displayMode, height = _a.height, isHeightUnknown = _a.isHeightUnknown, hideFooter = _a.hideFooter, bgColor = _a.bgColor;
    var search = useLocation().search;
    return (React.createElement(View, { url: mergeUrl(url, search), displayMode: displayMode, height: height, isHeightUnknown: isHeightUnknown, hideFooter: hideFooter, bgColor: bgColor }));
};
